export default __webpack_public_path__ + "static/media/icon-upload.074d6b3b.svg";